import { IResourceGroupListEntry } from "@app/main/components/resourceManagement/groups/_models/IResourceGroupListEntry";
import { IVeriTableHeader, IVeriTableRow } from "@directives/_veri/veriTable/veriTable.component";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { IDateFilter } from "@interfaces/filters/IDateFilter";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { HTMLService } from "@services/htmlService.service";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { IFilterBar, IFilterBarFilter, ResourceFilterBarComponentController } from "../newResourceFilterBar.component";
import "./tableColumnResourceFilter.scss";

interface IComponentBindings {
    filterIcon: string;
    column: string | number;
}

interface IColumnVariation {
    name: string;
    rows: IVeriTableRow<any>[];
    count: number;
}

export interface ITableColumnResourceFilter { }

class ComponentController implements angular.IComponentController, IComponentBindings, IFilterBarFilter<ITableColumnResourceFilter>{

    parent: IFilterBar;
    //veriTable: IVeriTableBindings<any>;

    column: string | number;
    columnHeader: IVeriTableHeader;

    filterName = "Column";
    filterLabel: string = "What";
    filterTitle: string;
    filterIcon: string;

    isPreTranslatedTitle = true;

    previousFilter: ITableColumnResourceFilter;

    show = false;
    isDirty = false;
    showClearFilterButton = true;

    onChange: (args: { filter: IDateFilter }) => void;

    columnVariations: IColumnVariation[] = [];
    selectedColumnVariations: IColumnVariation[] = [];

    parentResourceFilterBar: ResourceFilterBarComponentController;

    static $inject = ["$rootScope", "$q", "$element", "$timeout", "htmlService", "translationService"];

    constructor(
        private readonly $rootScope: IRunBlockRootScope,
        private readonly $q: angular.IQService,
        public readonly $element: HTMLElement,
        private readonly $timeout: angular.ITimeoutService,
        private readonly htmlService: HTMLService,
        private readonly translationService: TranslationService
    ) {
        var parent = this.htmlService.findNearest(this.$element[0], "new-resource-filter-bar");
        this.parentResourceFilterBar = this.htmlService.getAngularJSComponentFromElement<ResourceFilterBarComponentController>(parent);
    }

    $onInit() {
        this.waitForTable().then(() => {
            this.filterIcon = this.filterIcon || "subject";
            this.updateColumnDetails();
            this.parent.registerFilter(this);
        });
    }

    $onDestroy() {
        this.show = false;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.updateColumnDetails();
    }

    toggleFilter(show: boolean) {
        this.show = show;

        if (this.show) {
            this.createColumnVariations(this.parentResourceFilterBar.veriTable.rows);
        }
    }

    clearFilter() {
        this.selectedColumnVariations = [];
        this.show = 1 as any;

        this.onIncludedItemChanged();
        this.updateFilterLabel();
    }

    createFilterObject(): ITableColumnResourceFilter {
        return {
        };
    }

    createEntityCallback(columnVariation: IColumnVariation, newInclusionState?: boolean): IResourceGroupListEntry<IColumnVariation> {
        var included = newInclusionState;

        if (typeof newInclusionState != "boolean") {
            included = this.selectedColumnVariations.find(c => c.name == columnVariation.name) != null;
        }

        var entity = {
            id: columnVariation.name as any,
            data: columnVariation,
            title: columnVariation.name,
            subTitle: this.translationService.t("filters.tableColumnResourceFilter.items", columnVariation.count),
            included: included,            
        };

        return entity;
    }

    onIncludedItemChanged(item?: IResourceGroupListEntry<IColumnVariation>) {
        if (item) {
            if (item.included) {
                this.selectedColumnVariations.push(item.data);
            }
            else {
                this.selectedColumnVariations = this.selectedColumnVariations.filter(cv => cv.name !== item.data.name);
            }
        }

        var filterRows: IVeriTableRow<any>[] = [];

        if (this.selectedColumnVariations && this.selectedColumnVariations.length) {
            filterRows = this.selectedColumnVariations && this.selectedColumnVariations.map(x => x.rows).reduce((a, b) => a.concat(b));
        }

        this.parentResourceFilterBar.veriTable.setFilterRows(filterRows);

        this.updateFilterLabel();

        this.createFilterObject();

        this.$rootScope.$broadcast(BroadcastEvent.closeResourceFilterBar);
    }

    // ------------------

    private getTableHeaderIndexForColumn(): number {
        const columnNumber = this.parentResourceFilterBar.veriTable.headers.findIndex(h => {
            return h.title == this.column
                || h.title == this.translationService.t(`Common.${this.column}`)
                || h.id && h.id == this.column
        });

        if (columnNumber < 0) {
            console.error("Could not find", this.column);
        }

        return columnNumber;
    }

    private createColumnVariations(rows: IVeriTableRow<any>[]) {
        this.columnVariations = [];
        var columnNumber = this.getTableHeaderIndexForColumn();

        rows.forEach(row => {
            const cell = row.cells[columnNumber];

            const cellTitle = cell.summaryLabel || cell.contents;
            let cv = this.columnVariations.find(c => c.name == cellTitle);

            if (!cv) {
                cv = {
                    name: cellTitle,
                    count: 0,
                    rows: []
                };

                this.columnVariations.push(cv);
            }

            cv.count++;
            cv.rows.push(row);
        });

        //this.columnVariations.sort((x, y) => x.name.localeCompare(y.name));
    }

    private updateFilterLabel() {
        this.filterTitle = "";
        this.filterLabel = "";

        this.isDirty = false;

        if (this.selectedColumnVariations && this.selectedColumnVariations.length) {

            this.selectedColumnVariations.forEach(cv => {
                if (this.filterLabel.length > 0) { this.filterLabel += ", "; }

                this.filterLabel += cv.name;
            });

            this.isDirty = true;
        }
        else {
            this.filterLabel = this.columnHeader ? this.columnHeader.title : "Translation Missing";
        }

        this.filterName = this.filterLabel;
    }

    private waitForTable(waitCount = 5): angular.IPromise<any> {
        var promise = this.$q.when();

        if (!this.parentResourceFilterBar?.veriTable && waitCount > 0) {

            promise = this.$timeout(() => {
                return this.waitForTable(--waitCount);
            });
        }

        return promise;
    }

    private updateColumnDetails() {
        if (!this.parentResourceFilterBar?.veriTable) {
            return;
        }

        if (typeof this.column == "number") {
            this.column = this.parentResourceFilterBar.veriTable.headers[this.column].title;
        }

        var columnPosition = this.getTableHeaderIndexForColumn();
        if (columnPosition >= 0) {
            this.columnHeader = this.parentResourceFilterBar.veriTable.headers[columnPosition];
        }

        this.updateFilterLabel();
    }
}

export class TableColumnResourceFilterComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    require: { [index: string]: string; };
    template: string;

    constructor() {
        this.bindings = {
            filterIcon: "@icon",
            column: "@",

            onChange: "&"
        };

        this.require = {
            parent: "^newResourceFilterBar"
        };

        this.controller = ComponentController;
        this.template = require("./tableColumnResourceFilter.html");
    }
}
